var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _vm.showMainNavigation
      ? _c("div", { class: _vm.$style.headerProfile }, [_vm._t("header")], 2)
      : _c("div", { class: _vm.$style.drawerHead }, [
          _c(
            "div",
            {
              class: _vm.$style.backButton,
              on: { click: _vm.handleBackNavigation }
            },
            [
              _c("NsIcon", {
                class: _vm.$style.backIcon,
                attrs: { "icon-name": "icon-narrow-angle-left-24" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.drawerTitle }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.activeNavigation.title || _vm.activeNavigation.name
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.$style.closeButton,
              on: { click: _vm.handleCloseClick }
            },
            [
              _c("NsIcon", {
                class: _vm.$style.closeIcon,
                attrs: { "icon-name": "icon-close-24", size: "custom" }
              })
            ],
            1
          )
        ]),
    _vm._v(" "),
    _c(
      "nav",
      { attrs: { role: "navigation" } },
      [
        _vm.showMainNavigation && !_vm.hideTopNav
          ? _c("div", [
              _c(
                "a",
                {
                  class: _vm.$style.navItem,
                  attrs: { href: _vm.localHomeUrl }
                },
                [
                  _c("span", {
                    class: _vm.$style.navTitle,
                    domProps: { innerHTML: _vm._s(_vm.translations.home) }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showSubNavigation
          ? [
              _vm._l(_vm.activeNavigation.subnav, function(navItem, navIndex) {
                return _c("div", { key: navItem.title || navItem.name }, [
                  _vm.allowSubNavigation(navItem)
                    ? _c(
                        "a",
                        {
                          class: _vm.$style.navItem,
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.selectSubNavigation(navIndex)
                            }
                          }
                        },
                        [
                          _c("span", { class: _vm.$style.navTitle }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(navItem.title || navItem.name) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("NsIcon", {
                            class: _vm.$style.navIcon,
                            attrs: { "icon-name": "icon-direction-mc" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "a",
                        {
                          class: _vm.$style.navItem,
                          attrs: { href: navItem.href }
                        },
                        [
                          _c("span", { class: _vm.$style.navTitle }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(navItem.title || navItem.name) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                ])
              }),
              _vm._v(" "),
              _vm.showSeeAllLink
                ? _c("div", [
                    _c(
                      "a",
                      {
                        class: _vm.$style.navItem,
                        attrs: { href: _vm.activeNavigation.href }
                      },
                      [
                        _c("span", { class: _vm.$style.navTitle }, [
                          _vm._v(_vm._s(_vm.activeCategoryLinkText))
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.showMainNavigation
          ? [
              !_vm.hideJoinUs && _vm.joinUs.label && _vm.joinUs.link
                ? _c("div", [
                    _c(
                      "a",
                      {
                        class: _vm.$style.navItem,
                        attrs: { href: _vm.joinUs.link }
                      },
                      [
                        _c("span", { class: _vm.$style.navTitle }, [
                          _vm._v(_vm._s(_vm.joinUs.label))
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideLegalLinks
                ? _vm._l(_vm.limitedLegalLinks, function(link) {
                    return _c("div", { key: link.name }, [
                      _c(
                        "a",
                        {
                          class: _vm.$style.navItem,
                          attrs: { href: link.href }
                        },
                        [
                          _c("span", { class: _vm.$style.navTitle }, [
                            _vm._v(_vm._s(link.name))
                          ])
                        ]
                      )
                    ])
                  })
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.activeNavigationCustomComponent
          ? _c(
              "div",
              [
                _c("NsDynamicHtml", {
                  attrs: { template: _vm.activeNavigationCustomComponent }
                })
              ],
              1
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.showMainNavigation
      ? _c(
          "div",
          { class: _vm.$style.secondaryActions },
          [
            !_vm.hideLoyalty
              ? _c("NsHeaderLoyaltyRewards", {
                  attrs: { translations: _vm.translations, mobile: "" }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.hideRegionSelector
              ? _c(
                  "div",
                  { class: _vm.$style.region },
                  [
                    _c(
                      "div",
                      {
                        class: _vm.$style.regionToggle,
                        on: { click: _vm.toggleRegionDropdown }
                      },
                      [
                        _c("div", [
                          _c("span", { class: _vm.$style.regionCountry }, [
                            _vm._v(_vm._s(_vm.regionDisplay.countryName))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "(" + _vm._s(_vm.regionDisplay.countryCode) + ")"
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { class: _vm.$style.regionLanguage }, [
                            _vm._v(
                              _vm._s(_vm.regionDisplay.language) +
                                "\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("NsIcon", {
                          class: [
                            _vm.$style.downIcon,
                            ((_obj = {}),
                            (_obj[_vm.$style.open] = _vm.regionSelectorOpen),
                            _obj)
                          ],
                          attrs: {
                            "icon-name": "icon-narrow-angle-bottom-24",
                            size: "custom"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "NsAnimateHeight",
                      { attrs: { open: _vm.regionSelectorOpen } },
                      [
                        _c(
                          "div",
                          { class: _vm.$style.regionDropdown },
                          [
                            _vm._l(_vm.regionDisplay.otherLanguages, function(
                              langItem
                            ) {
                              var _obj
                              return _c(
                                "a",
                                {
                                  key: langItem.language,
                                  class: [
                                    _vm.$style.regionOption,
                                    ((_obj = {}),
                                    (_obj[_vm.$style.active] = langItem.active),
                                    _obj)
                                  ],
                                  attrs: { href: langItem.path }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(langItem.language) +
                                      "\n          "
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("a", {
                              class: [
                                _vm.$style.regionOption,
                                _vm.$style.otherRegion
                              ],
                              attrs: { href: "javascript:void(0)" },
                              domProps: {
                                innerHTML: _vm._s(_vm.translations.selectOther)
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.selectOtherRegion($event)
                                }
                              }
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showFooterNav
      ? _c("div", { class: _vm.$style.footerNav }, [
          !_vm.hideFooterSignup
            ? _c("div", { class: _vm.$style.footerNavHead }, [
                _c("button", {
                  staticClass: "ghost-inverse fluid",
                  domProps: {
                    innerHTML: _vm._s(_vm.translations.sendSignupInvite)
                  },
                  on: { click: _vm.handleFooterSignupClick }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.footerNavBody },
            [
              _c("NsFooterNav", {
                attrs: {
                  navigation: _vm.footerNavigation,
                  expandbreakpoint: "none"
                }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }